export const util = {
///////////////////////////////////////////////// strings,number
    // convierte a número tanto "1.234,56" (formato español) como "1234.56" (con punto decimal)
    SN(str='') {
        if (typeof str==='number') return str;
        if (str===null || str===undefined || str==='') return 0;

        let s=String(str).trim();
        // si lleva coma, es formato español: el punto es separador de miles y la coma el decimal
        if (s.includes(',')) s=s.replace(/\./g, '').replace(',', '.');

        let n=parseFloat(s);
        return isNaN(n) ? 0 : n;
    },
    NS(str='') {
        let num=str.replace('.', '');
        num=str.replace(',', '.');
        return Number(num);
    },
    

    round(val=0,dec=100) {       
        return Math.round(val * dec) / dec;
    },

//////////////////////////////////////////////// arrrays    
    array_object(arr) {
        let obj = [...arr.entries()].reduce((obj, [key, value]) => (obj[key] = value, obj), {});
        return obj;
    },
    array_valores(arr, prop) {
        var A=arr;
        if (typeof(arr)==='object') { // pasamos a array
            A=this.object_array(arr);
        }
        return A.map(function(e) { return e[prop]; }).filter(function(e,i,a){
            return i === a.indexOf(e);
        }).sort();
      },
      object_array(obj) {
          let result=Object.keys(obj).map(function(key) {
              return obj[key];
          });
          return result;
    },

//////////////////////////////////////////////////////////////////
    validaCIF(nif) {
        nif = nif.toUpperCase().replace(/[_\W\s]+/g, '');
        if(/^(\d|[XYZ])\d{7}[A-Z]$/.test(nif)) {
            let num = nif.match(/\d+/);
            num = (nif[0]!='Z'? nif[0]!='Y'? 0: 1: 2)+num;
            if(nif[8]=='TRWAGMYFPDXBNJZSQVHLCKE'[num%23]) {
                return /^\d/.test(nif)? 'DNI': 'NIE';
            }
        }
        else if(/^[ABCDEFGHJKLMNPQRSUVW]\d{7}[\dA-J]$/.test(nif)) {
            var par = 0; 
            var non = 0;
            //letras = "ABCDEFGHKLMNPQS";
            //let = nif.charAt(0);
                    
            for (let zz=2;zz<8;zz+=2) {
                par = par+parseInt(nif.charAt(zz));
            }                
            for (let zz=1;zz<9;zz+=2) {
                let nn = 2*parseInt(nif.charAt(zz));
                if (nn > 9) nn = 1+(nn-10);
                non = non+nn;
            }    
            let parcial = par + non;
            let control = (10 - ( parcial % 10));
            if (control==10) control=0;
                
            if (control!=nif.charAt(8)) {
                //alert("El Cif no es válido");
                return false;
            }
            //alert("El Cif es válido");
            return true;
/* 
            var even_sum = 0;
            var odd_sum = 0;
            var n;

            for (let i=1;i<8;++i) {
                //let num = nif[i]<<i%2;
                //sum += parseInt(num / 10) + num % 10
                n = parseInt( nif[i], 10 );
                if ( i % 2 === 0 ) {
                  n *= 2;
                  odd_sum += n < 10 ? n : n - 9;
                } else {
                  even_sum += n;
                }
            }
            var c = (10 - (even_sum + odd_sum).toString().substr(-1) );
            if( ((/[KLMNPQRSW]/.test(nif[0]) || (nif[1]+nif[2])=='00') && nif[8]=='JABCDEFGHI'[c]) ||
                (/[ABEH]/.test(nif[0]) && nif[8]==c) ||
                (/[CDFGJUV]/.test(nif[0]) && (nif[8]=='JABCDEFGHI'[c] || nif[8]==c)) ) {
                return /^[KLM]/.test(nif)? 'ESP': 'CIF';
            }
 */        
        }
        return false;
    }

    
    
}   